module.exports = __webpack_public_path__ + "static/media/attendance-report-video-icon.5ba3522b.svg";